import { GET_SHIPPING_ZONES } from '../actions/ShippingZones';

const initialState = {
  shippingZones: [],
};

const ShippingZonesReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SHIPPING_ZONES:
      return {
        ...state,
        shippingZones: action.payload.data || [],
      };
    default:
      return state;
  }
};

export default ShippingZonesReducer;
